<template>
  <div class="selector-grid__item selector-grid__item--dress"
       :class="selectedDress && selectedDress === item  ? 'selected' : ''"
       @click="setDress(item)">


    <!--todo how is not reactive-->
    <!--<div v-if="!item.loaded" class="loading-bar text-red absolute">loading</div>-->

    <div class="selector-grid__image-container selector-grid__image-container--dress" :style="{backgroundImage: `url(${item.image})`}" alt=""></div>
    <h4 class="selector-grid__title selector-grid__title--dress">{{ '0'+(i+1) }}</h4>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: "DressItem",
    props: {
      item: {
        type: Object,
        required: true,
      },
      i: {
        type: Number,
        default: 0,
      }
    },
    computed: {
      ...mapGetters('clothes', [
        'selectedDress',
        'dressById'
      ]),
    },
    methods: {
      ...mapActions('clothes',[
        'wearDress',
      ]),
      ...mapActions([
        'render'
      ]),
      setDress(item) {

        this.$Progress.start();
        this.wearDress(item).then( () => {
          // console.log('in component render');
          this.render();
          this.$Progress.finish();
        });
      }
    },
  }
</script>

<style scoped>
  .selector-grid__item--dress {
    width: 30%;
  }

  .selector-grid__image-container--dress {
    padding-top: 130%;
    background-size: contain;
    border-left-color: transparent!important;
    border-right-color: transparent!important;
    border-top-color: transparent!important;
  }

  .loading-bar {
    top: 50%;
    height: 15px;
    text-align: center;
    transform: translateY(-8px);
    width: 100%;
    font-size: 12px;
  }
</style>